import { isAdmin } from '../actionHelper';
import { Carriers } from '../constants/carriers';
import { USStates } from '../constants/countryStates';
import { DebitsValue, RateClass } from '../constants/decision';
import { Products } from '../constants/products';
import { RiderNames } from '../constants/rider';
import { UserOrganization } from '../constants/userOrganization';
import { ProductConfig } from './productConfig';

export class NorthAmericanNAIULACUM extends ProductConfig {
  getCarrier(): Carriers {
    return Carriers.NORTH_AMERICAN;
  }
  getProduct(): Products {
    return Products.NAIULACUM;
  }
  availableToOrganization(org: UserOrganization): boolean {
    return [UserOrganization.NORTH_AMERICAN, UserOrganization.ETHOS].includes(
      org,
    );
  }
  getColor(): string {
    return 'Coral';
  }
  showPolicyCombined(roles: string[], org: string) {
    return (
      org === UserOrganization.NORTH_AMERICAN ||
      (isAdmin(roles) && org === UserOrganization.ETHOS)
    );
  }
  showPercentageAddition(rateClass: string | undefined): boolean {
    return rateClass === RateClass.STANDARD;
  }
  showDebits(rateClass: string | undefined): boolean {
    return rateClass === RateClass.STANDARD;
  }
  hasPercentageAddition(): boolean {
    return true;
  }
  hasTableRating(): boolean {
    return true;
  }
  getDebitsList(): DebitsValue[] {
    return [
      DebitsValue.Debits_0,
      DebitsValue.Debits_50,
      DebitsValue.Debits_75,
      DebitsValue.Debits_100,
      DebitsValue.Debits_125,
      DebitsValue.Debits_150,
      DebitsValue.Debits_175,
      DebitsValue.Debits_200,
    ];
  }
  getPa(debits: number): number {
    if (debits >= DebitsValue.Debits_175) {
      return 300;
    }
    return debits + 100;
  }
  medicalExamAvailable(): boolean {
    return true;
  }
  ETIAvailable(): boolean {
    return true;
  }
  hasStandardPlusRating(_flags: any): boolean {
    return false;
  }
  showTobaccoForPreferred(_flags: any): boolean {
    return true;
  }
  getUnderWritableRiders(state: string): string[] {
    if (state === USStates.CA) {
      return [
        RiderNames.RETURN_PREMIUM_DEATH_BENEFIT_ENDORSEMENT,
        RiderNames.ADBE_CHRONIC,
        RiderNames.ADBE_CRITICAL,
        // ADBE_TERMINAL is always available for CA, it will be disabled in the UI
      ];
    }
    return [
      RiderNames.RETURN_PREMIUM_DEATH_BENEFIT_ENDORSEMENT,
      RiderNames.ACCIDENTAL_DEATH_BENEFIT,
      RiderNames.ADBE_CHRONIC,
      RiderNames.ADBE_CRITICAL,
      RiderNames.WAIVER_MONTHLY_DEDUCTIONS,
      RiderNames.FLEXIBLE_BENEFIT,
      // ADBE_TERMINAL is always available for non-CA, it will be disabled in the UI
    ];
  }
  getProductDisplayText(): string {
    return `${this.getCarrier()} IUL`;
  }
}
